/**
 * Monotonic counter bumped on every non-idempotent API call.
 *
 * Stores use it to know whether an in-flight GET was started before or after
 * the last write: a response older than a write may be stale and must not be
 * shared with a caller that asked for data after that write.
 */
let writeEpoch = 0;

const READ_METHODS = new Set(["get", "head", "options"]);

/**
 * @returns {number}
 */
export function getApiWriteEpoch() {
    return writeEpoch;
}

/**
 * Registers the request interceptor bumping the epoch on writes.
 * @param {import("axios").AxiosInstance} client
 * @returns {void}
 */
export function trackApiWrites(client) {
    client.interceptors.request.use((config) => {
        const method = String(config?.method || "get").toLowerCase();
        if (!READ_METHODS.has(method)) {
            writeEpoch += 1;
        }
        return config;
    });
}
